import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import FormInput from '../FormInput';
import Button from '../Button';
import AutoCompleteInput from '../AutoCompleteInput';
import Modal from '../Modal';

interface ModalInserirProdutoProps {
  onClose: () => void;
  onAdicionar: (produto: string, quantidade: number, valorUnitario: number) => void;
  produtoParaEditar?: any;
}

export default function ModalInserirProduto({ onClose, onAdicionar, produtoParaEditar }: ModalInserirProdutoProps) {
  const [produto, setProduto] = useState<any>(produtoParaEditar);
  // Alterar: abre com a quantidade e o valor já lançados no item
  const [quantidade, setQuantidade] = useState(produtoParaEditar?.qua != null ? String(produtoParaEditar.qua) : '1');
  const [valorUnitario, setValorUnitario] = useState(produtoParaEditar?.val != null ? String(produtoParaEditar.val) : '0');

  const handleSubmit = () => {
    if (!produto) return toast.warning('Selecione um produto');
    if (!quantidade || +quantidade <= 0) return toast.warning('Quantidade inválida');

    onAdicionar(produto, +quantidade, +valorUnitario);

    setProduto(undefined);
    setQuantidade('1');
    setValorUnitario('0');
  };

  // Produto escolhido na busca traz o preço de venda (no alterar o valor já veio do item)
  useEffect(() => {
    if (produto && produto !== produtoParaEditar) {
      setValorUnitario(produto.val);
    }
  }, [produto]);

  useEffect(() => {
    if (produtoParaEditar) {
      setProduto(produtoParaEditar);
      setQuantidade(String(produtoParaEditar.qua ?? '1'));
      setValorUnitario(String(produtoParaEditar.val ?? '0'));
    }
  }, [produtoParaEditar]);

  return (
    <Modal
      titulo={produtoParaEditar ? 'Alterar produto' : 'Inserir produto'}
      onClose={onClose}
      rodape={
        <>
          <Button texto='Cancelar' variante='secundario' onClick={onClose} />
          <Button texto='Salvar' onClick={handleSubmit} />
        </>
      }
    >
      <AutoCompleteInput
        label='Produto'
        setState={setProduto}
        defaultValue={produto?.mer}
        readOnly={Boolean(produtoParaEditar)}
      />
      <FormInput
        placeHolder='Quantidade'
        value={quantidade}
        onChange={e => setQuantidade(e.target.value)}
        type='number'
        inputMode='decimal'
      />
      <FormInput
        placeHolder='Vlr Unitário'
        value={valorUnitario}
        onChange={e => setValorUnitario(e.target.value)}
        type='number'
        inputMode='decimal'
        step='0.01'
      />
    </Modal>
  );
}
